import React, { ReactNode } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import ReactDOM from "react-dom";

type ModalProdutoAlternativoProps = {
  children?: ReactNode,
  visivel: boolean,
  save: any,
  hide: any
};

type ModalProdutoAlternativoState = {
  enabled: boolean,
};

class ModalProdutoAlternativo extends React.Component<ModalProdutoAlternativoProps, ModalProdutoAlternativoState> {

  constructor(props: ModalProdutoAlternativoProps) {
    super(props);

    this.saveProdutoAlternativo = this.saveProdutoAlternativo.bind(this);
    this.saveEnabled = this.saveEnabled.bind(this);

    this.state = {
      enabled: false,
    };
  }

  saveProdutoAlternativo(): void {
    const substituir: any = ReactDOM.findDOMNode(this.refs.checkSubstituir);
    const adicionar: any = ReactDOM.findDOMNode(this.refs.checkNaoAdicionar);

    if (substituir.checked) {
      this.props.save(substituir.value);
    }
    if (adicionar.checked) {
      this.props.save(adicionar.value);
    }
  }

  saveEnabled(enabled: boolean): void {
    this.setState({ enabled });
  }

  render(): any {
    return (
      <Dialog open={this.props.visivel}>
        <DialogContent>
          <div className="modal disponivel" id="subs-modal">
            <p className="title">O que deseja caso algum produto selecionado não esteja disponível?</p>
            <p className="menu-item">
              <input type="radio" ref="checkSubstituir" name="nd" value="Substituir por produto similar"
                onClick={ () => this.saveEnabled(true) } id="checkSubstituir" />
              <label htmlFor="checkSubstituir">Substituir por produto similar</label>
            </p>
            <p className="menu-item">
              <input type="radio" ref="checkNaoAdicionar" name="nd" value="Não adicionar outro produto"
                onClick={ () => this.saveEnabled(true) } id="checkNaoAdicionar" />
              <label htmlFor="checkNaoAdicionar">Não adicionar outro produto</label>
            </p>
            { !this.state.enabled &&
            <div className="menu inactive">
              <button onClick={ this.props.hide }>Cancelar</button>
              <button className="confirmar">Confirmar</button>
            </div>
            }
            { this.state.enabled &&
            <div className="menu">
              <button onClick={ () => { this.props.hide(); this.saveEnabled(false); } }>Cancelar</button>
              <button className="confirmar" onClick={ this.saveProdutoAlternativo }>Confirmar</button>
            </div>
            }
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

export default ModalProdutoAlternativo;